import { render, staticRenderFns } from "./ProductionOrderDetails.vue?vue&type=template&id=2aa528bb&scoped=true"
import script from "./ProductionOrderDetails.vue?vue&type=script&lang=js"
export * from "./ProductionOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductionOrderDetails.vue?vue&type=style&index=0&id=2aa528bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa528bb",
  null
  
)

export default component.exports